export const stringsKey = "IVRStudioFlow";
export const englishStrings = {
	reactFlowHeader: "React Flow of the configured widget(s)",
};
